// extracted by mini-css-extract-plugin
export default {"starterScreen":"Jl","starterImage":"Kl","already":"Ll","btnContainer":"Ml","starterImageMobile":"Nl","starterTextContainWrapper":"Ol","controlX":"Pl","attrWrapper":"Ql","logoWrapper":"Rl","starterTextContain":"Sl","starterHeader":"Tl","starterBtn":"Ul","starterSecondaryBtn":"Vl","starterBanner":"Wl","logoWrapperMob":"Xl","mobileBtnContainer":"Yl"};
    if(module.hot) {
      // 1714422952468
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  